// lib/studio-viewport.ts
import type { CSSProperties } from 'react';

// The element whose transform carries a viewport's pan and zoom; in the Studio, written by applyViewportTransform (kernel/useZoom.ts).
export const VIEWPORT_TRANSFORM_CONTAINER_SELECTOR = '[data-viewport-transform-container="true"]';

// Dispatched synchronously on the Studio viewport element by applyViewportTransform after each transform write.
export const STUDIO_VIEWPORT_TRANSFORM_EVENT = 'fater:studio-viewport-transform';

// Written on the Studio canvas container by applyViewportTransform on every pan and zoom frame, for screen-space overlays.
export const STUDIO_LIVE_VIEWPORT_VARS = {
  panX: '--viewport-live-pan-x',
  panY: '--viewport-live-pan-y',
  zoom: '--viewport-live-zoom',
} as const;

// For subtrees that never read them (world-space scene, version strip content): inherited, every pan frame would restyle
// each of their descendants. A reader placed under this reset falls back to the committed values and lags the gesture.
export const STUDIO_LIVE_VIEWPORT_VARS_RESET = Object.fromEntries(
  Object.values(STUDIO_LIVE_VIEWPORT_VARS).map((name) => [name, 'initial']),
) as CSSProperties;
